
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <img src="{{caminhoImagem}}" class="img-fluid d-block" alt="Preço da Hora"/>
    </div>


// WEBPACK FOOTER //
// ./src/app/shared/modal/nbp-modal-imagem.component.ts.NbpModalImagemComponent.html